module.exports = __webpack_public_path__ + "static/palettteapp-e943e67c08112962b488ee5c5ae39d76.jpg";